import { BaseModel } from "models/BaseModel";
import { CategoryProps, CategoryFields } from "./types";

export class Category extends BaseModel {
	[CategoryFields.ID]: string;
	[CategoryFields.NAME]: string;

	constructor(data: CategoryProps) {
		super(data);

		this[CategoryFields.ID] = data[CategoryFields.ID];
		this[CategoryFields.NAME] = data[CategoryFields.NAME];
	}
}
